import React from 'react'
import { cn } from '@/lib/utils'
interface ContainerProps {
  children: React.ReactNode;
  className?: string;
}

const Container:React.FC<ContainerProps> = ({children,className}) => {
  return (
    <div className={cn('flex flex-col items-start p-5 md:p-8 lg:p-8 xl:p-8 2xl:p-8 rounded-[9px] bg-white', className)}>
        {children}
    </div>
  )
}

export default Container